import React, { useState } from "react";
import useDiscount from "../Hooks/useDiscount";

const CartItemsCheckout = ({ formData,handleInputChange, items, subtotal, total, shipping }) => {
  const { discountedPrice, applyDiscount, error, loading } = useDiscount();
  const handleApplyDiscount = () => {
    if (formData.discount_code.trim()) {
      applyDiscount(formData.discount_code, subtotal);
    }
  };

  return (
    <div>
      <h2 className="text-xl font-bold">Order Summary</h2>
      <div className="space-y-4">
        {items.map((item, index) => (
          <div key={index} className="flex items-center pb-4 relative">
            {/* Image with quantity circle */}
            <div className="relative">
              <img
                src={item.image}
                alt={item.name}
                className="w-12 h-16 object-cover rounded"
              />
              {/* Quantity circle */}
              <div className="absolute top-[-7px] right-[-7px] bg-gray-600 text-white text-xs font-bold rounded-full w-6 h-6 flex items-center justify-center">
                {item.quantity}
              </div>
            </div>

            {/* Item details */}
            <div className="flex flex-col ps-2 md:ps-3 flex-1">
              <div className="flex-1">
                <h3 className="text-sm font-medium truncate">{item.name}</h3>
                {/* <p className="text-sm font-bold">Rs. {item.price}</p>
                <p className="text-xs text-gray-500">Size: {item.size}</p> */}
              </div>
            </div>

            {/* Total amount */}
            <div className="text-right text-sm font-medium text-gray-700">
              Rs. {item.price * item.quantity}
            </div>
          </div>
        ))}
      </div>
      
      <div className="flex flex-col mb-4 pb-4">
        <div  className="flex">

  <div className="flex items-center border bg-none w-100 border-gray-300 me-3 rounded-md overflow-hidden">
    {/* Input */}
    <input
      type="text"
      name="discount_code"
      value={formData.discount_code}
      onChange={handleInputChange}
      className="flex-1 p-2 bg-transparent text-sm border-none focus:ring-0 focus:outline-none"
      placeholder="Discount code or gift card"
    />
    </div>
    {/* Button */}
    <button
      onClick={handleApplyDiscount}
      className="bg-gray-100 text-gray-600 text-sm font-medium px-3 border-2 border-gray-300 rounded py-3 hover:bg-gray-200 disabled:bg-gray-200 disabled:text-gray-400"
      disabled={loading}
    >
      {loading ? "Applying..." : "Apply"}
    </button>
    </div>

  {error && <p className="text-red-500 mt-2 text-sm">{error}</p>}
</div>

      <div className="flex justify-between">
        <span>Subtotal</span>
        <span className="font-medium">Rs. {subtotal.toLocaleString()}</span>
      </div>
        {discountedPrice !== null && (
          <div className="flex justify-between">
            <span className="font-medium">Discount</span>
            <span className="font-medium">
              Rs. - {(subtotal - discountedPrice).toLocaleString()}
            </span>
          </div>
        )}
      <div className="flex justify-between">
        <span>Shipping</span>
        <span className="font-medium">Rs. {shipping}</span>
      </div>
      <div className="mt-4">
        <div className="flex justify-between">
          <span>Total</span>
          <span className="font-bold text-xl">
            Rs. {(discountedPrice ?  discountedPrice + shipping : total).toLocaleString()}
          </span>
        </div>
      </div>
      <p className="p-4 border border-black rounded font-semibold text-xm mt-3">
        
Note: You may receive multiple packages for one order (local orders only) . Items bought on sale are non-exchangeable & non-returnable. Nationwide orders will be delivered within 5 - 7 working days. If you have any queries, contact us at wecare@Mishaaf.pk
      </p>
    </div>
  );
};

export default CartItemsCheckout;
